export default [
    {
        name: 'Company',
        path: 'Company',
        component: () => import('@/pages/About/Company'),
        meta: { title: '公司简介' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
         
            }
        }
    },
    {
        name: 'History',
        path: 'History',
        component: () => import('@/pages/About/History'),
        meta: { title: '发展历程' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
         
            }
        }
    },
    {
        name: 'Qualification',
        path: 'Qualification',
        component: () => import('@/pages/About/Qualification'),
        meta: { title: '荣誉资质' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
         
            }
        }
    },
    {
        name: 'TeamSpirit',
        path: 'TeamSpirit',
        component: () => import('@/pages/About/TeamSpirit'),
        meta: { title: '团队风采' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
         
            }
        }
    },
    {
        name: 'CooperativeClients',
        path: 'CooperativeClients',
        component: () => import('@/pages/About/CooperativeClients'),
        meta: { title: '合作客户' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
         
            }
        }
    },
    {
        name: 'CaseShowcase',
        path: 'CaseShowcase',
        component: () => import('@/pages/About/CaseShowcase'),
        meta: { title: '案例展示' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
         
            }
        }
    },
    {
        name: 'TalentRecruitment',
        path: 'TalentRecruitment',
        component: () => import('@/pages/About/TalentRecruitment'),
        meta: { title: '人才招聘' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
         
            }
        }
    }
]